import { Duration } from '../types/duration.type';

export function durationToSeconds(duration: Duration): number {
  return duration.minutes * 60 + duration.seconds;
}

export function secondsToDuration(seconds: number): Duration {
  return {
    minutes: Math.floor(seconds / 60),
    seconds: seconds % 60,
  };
}

/** `m:ss`, ou `h:mm:ss` au dela d'une heure. */
export function formatTime(totalSeconds: number): string {
  const hours: number = Math.floor(totalSeconds / 3600);
  const minutes: number = Math.floor((totalSeconds % 3600) / 60);
  const seconds: string = String(totalSeconds % 60).padStart(2, '0');
  if (hours) return `${hours}:${String(minutes).padStart(2, '0')}:${seconds}`;
  return `${minutes}:${seconds}`;
}

export function formatShortDuration(totalSeconds: number): string {
  if (!totalSeconds) return '-';
  if (totalSeconds < 60) return `${totalSeconds}s`;
  const { minutes, seconds }: Duration = secondsToDuration(totalSeconds);
  return seconds ? `${minutes}min${seconds}s` : `${minutes}min`;
}
